import { render, staticRenderFns } from "./QuestionSlotCard.vue?vue&type=template&id=ac604cbc&scoped=true&"
import script from "./QuestionSlotCard.vue?vue&type=script&lang=js&"
export * from "./QuestionSlotCard.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSlotCard.vue?vue&type=style&index=0&id=ac604cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac604cbc",
  null
  
)

export default component.exports